module.exports = __webpack_public_path__ + "img/circle_alert_four.67adbff7.svg";